import axios from 'axios';

// Always point to the production API unless explicitly overridden
const axiosConn = axios.create({
  baseURL:
    process.env.REACT_APP_AZURE_API_BASE_URL ||
    process.env.REACT_APP_API_BASE_URL_PROD ||
    '/api/v1',
});

export default axiosConn;
